import React from 'react'
import Formsy from 'formsy-react'
import createReactClass from 'create-react-class'

const Radio = createReactClass({
	mixins: [Formsy.Mixin],
	componentDidMount() {
		const value = this.props.value
		this.setValue(value)
		this.setState({ value })
	},
	changeValue(value) {
		this.setValue(value)
		this.setState({ value })	
		const { onClick } = this.props
		if (onClick) {
			onClick(value)
		}
	},
	render() {
		const className = `form-group${  this.props.className || ' ' 
		}${this.showRequired() ? 'required' : this.showError() ? 'error' : ''}`
		const errorMessage = this.getErrorMessage()
		const { name, title, items, iconClass, widthClass, image } = this.props
		return (
			<div className={className}>
				{items.map((item, i) => (
					<div key={i} className={widthClass}>
						{ image ? <span></span> : <i className={iconClass}></i> }
						<label className="bv-form-label">{ i == 0 && !image ? title : <span>&nbsp;</span> }</label>
						<span className={ this.getValue() == item ? "bv-form-radio bv-form-radio-active" : "bv-form-radio"} onClick={this.changeValue.bind(this, item)} >
							{ image ? "" : item.toUpperCase() }
							{ image ? <img src={`/assets/hostlogos/${item.toLowerCase()}.png`} style={{height: "46px"}}/> : <span></span> }
							<i className="mdi mdi-check-circle"></i>
						</span>
					</div>
				))
				}
				<span className='validation-error'>{errorMessage}</span>
			</div>
		)
	}
})

export default Radio
